export default class ChartSeries {
  public constructor(name: string, data: Array<number>) {
    this.name = name;
    this.data = data;
  }

  public name: string;
  public data: Array<number>;
}
